// extracted by mini-css-extract-plugin
export default {"productCarousel":"L0-z"};